<template>
<zm-dialog :title="form.title" :visible.sync="visible" width="80%" class="short-dialog">
    <zm-form :model="form" label-position="left" :rules="rules" ref="form" v-show="active === 0" label-width="120px">
        <zm-form-item label="name" prop="name">
            <div slot="label">
                <tip label="name" id="user-name"></tip>
            </div>
            <zm-input size="small" v-model.trim="form.name" v-if="isCreate"></zm-input>
            <zm-select size="small" v-model.trim="form.id" filterable v-else @change="fetchUserById">
                <zm-option v-for="item in users" :key="item.id" :label="item.name" :value="item.id"></zm-option>
            </zm-select>
        </zm-form-item>
        <zm-form-item label="role" prop="role">
            <div slot="label">
                <tip label="role" id="user-role"></tip>
            </div>
            <zm-select size="small" v-model="form.role">
                <!-- <zm-option label="ADMIN" value="ADMIN" v-if="role !== 'APP'"></zm-option> -->
                <zm-option label="APP" value="APP"></zm-option>
                <!-- <zm-option label="REVIEWER" value="REVIEWER"></zm-option>
                <zm-option label="DEVELOPER" value="DEVELOPER"></zm-option>
                <zm-option label="READONLY" value="READONLY"></zm-option> -->
            </zm-select>
        </zm-form-item>
        <zm-form-item label="emails" prop="emails">
            <div slot="label">
                <tip label="emails" id="user-emails"></tip>
            </div>
            <zm-input size="small" v-model.trim="form.emails" placeholder="san.zhang@zoom.us,si.li@zoom.us,"></zm-input>
        </zm-form-item>
        <zm-form-item label-width="0">
            <zm-checkbox v-model="form.enableAlert">
                <tip label="enable alert" id="user-enableAlert"></tip>
            </zm-checkbox>
        </zm-form-item>
        <zm-form-item label-width="0">
            <zm-checkbox v-model="form.enableReport">
                <tip label="enable report" id="user-enableReport"></tip>
            </zm-checkbox>
        </zm-form-item>
        <zm-form-item label="description" prop="description">
            <div slot="label">
                <tip label="description" id="user-description"></tip>
            </div>
            <zm-input size="small" type="textarea" :autosize="{ minRows: 1, maxRows: 4}" v-model="form.description"></zm-input>
        </zm-form-item>
        <zm-form-item label-width="0">
            <zm-checkbox v-model="form.active">
                <tip label="active" id="user-active"></tip>
            </zm-checkbox>
        </zm-form-item>
        <zm-form-item label="webhookChannel">
            <div slot="label">
                <tip label="webhookChannel" id="user-webhookChannel"></tip>
            </div>
            <zm-select multiple size="small" v-model="form.webhookChannelIds" :checkbox-options="webhookList">
            </zm-select>
        </zm-form-item>
    </zm-form>
    <zm-form v-if="active === 1">
        <div v-for="item in extraInfos" :key="item.key">
            <zm-form-item label-width="100%" required>
                <template slot="label">
                    <tip :label="item.key" :id="'requestTopic-extraInfo-' + item.key"></tip>
                </template>
            </zm-form-item>
            <zm-form-item label-width="0">
                <zm-input type="textarea" size="small" v-model="item.value"></zm-input>
            </zm-form-item>
        </div>
    </zm-form>
    <zm-steps :active="active" finish-status="success" style="margin-top: 10px;">
        <zm-step title="User Form"></zm-step>
        <zm-step title="Questions"></zm-step>
    </zm-steps>
    <div slot="footer" class="dialog-footer">
        <zm-button size="small" @click="visible = false">Cancel</zm-button>
        <zm-button size="small" type="primary" @click="active--" v-if="active">Previous</zm-button>
        <zm-button size="small" type="primary" @click="next()" v-if="active < 1">Next</zm-button>
        <zm-button size="small" type="primary" @click="save()" :loading="loading" v-if="active === 1">Submit</zm-button>
    </div>
</zm-dialog>
</template>
<script>
import { listWebhook } from '@/api/webhook'
import { getAllUser, getUserListById } from '../../api/index'
import { createRequest, updateRequest,
getRequestExtraInfo,
getRequestById
} from '../../api/request'
import tip from 'components/ToolTip/index'
export default {
    name: 'createUser',
    components: {
        tip
    },
    props: ['row', 'isCreate'],
    data () {
        var validateName = (rule, value, callback) => {
            if (value === '') {
                callback(new Error('please enter name'))
            } else {
                var arr = ['&', '\\', '/', '*', '>', '<', '!']
                var reg = /[\u4E00-\u9FA5\uF900-\uFA2D]/
                if (!reg.test(value)) {
                    for (var i = 0; i < arr.length; i++) {
                        for (var j = 0; j < value.length; j++) {
                            if (arr[i] === value.charAt(j)) {
                                callback(new Error('invalid name!'))
                            }
                        }
                    }
                    callback()
                }
                callback(new Error('invalid name!'))
            }
        }
        var validateEmail = (rule, value, callback) => {
            if (value === '') {
                callback(new Error('please enter email'))
            } else {
                const emails = value.split(',')
                for (var item in emails) {
                    var apos = emails[item].indexOf('@')
                    var lastapos = emails[item].lastIndexOf('@')
                    var dotpos = emails[item].lastIndexOf('.')
                    if ((apos < 1 || dotpos - apos < 2 || apos !== lastapos) && emails[item] !== '') {
                        callback(new Error('invalid emails!'))
                    }
                }
                callback()
            }
        }
        return {
            role: localStorage.role,
            users: [],
            loading: false,
            visible: false,
            active: 0,
            requestParam: {
                type: 'CREATE_USER'
            },
            webhookList: [],
            form: {
                title: '',
                id: '',
                emails: '',
                role: '',
                active: true,
                enableAlert: false,
                enableReport: false,
                name: '',
                webhookChannelIds: [],
                description: ''
            },
            extraInfos: [],
            extraLoading: false,
            rules: {
                name: [
                    { required: true, validator: validateName, trigger: 'blur' }
                ],
                role: [
                    { required: true, message: 'please enter role', trigger: 'blur' }
                ],
                emails: [
                    { required: true, validator: validateEmail, trigger: 'blur' }
                ],
                description: [
                    { required: true, message: 'please enter description', trigger: 'blur' }
                ]
            }
        }
    },
    watch: {
        visible () {
            if (this.visible) {
                this.active = 0
                this.init()
            }
        }
    },
    methods: {
        init () {
            if (this.row) {
                if (!this.isCreate) {
                    this.requestParam.type = 'EDIT_USER'
                    this.showEditTopic()
                    this.getAllUser()
                } else {
                    this.requestParam.type = 'CREATE_USER'
                    this.showEditTopic()
                }
            } else {
                if (!this.isCreate) {
                    this.requestParam.type = 'EDIT_USER'
                    this.showCreateTopic()
                    this.getAllUser()
                } else {
                    this.requestParam.type = 'CREATE_USER'
                    this.showCreateTopic()
                }
            }
        },
        showCreateTopic () {
            this.form.title = 'Create Request'
            this.form.name = ''
            this.form.role = 'APP'
            this.form.emails = ''
            this.form.description = ''
            this.form.enableAlert = true
            this.form.enableReport = true
            this.form.active = true
            this.form.webhookChannelIds = []
            getRequestExtraInfo(this.requestParam.type).then(response => {
                response[this.requestParam.type].map(item => {
                    this.extraInfos.push({
                        key: item,
                        value: ''
                    })
                })
                this.extraLoading = false
            }).catch(() => {
                this.extraLoading = false
            })
        },
        fetchUserById () {
            if (this.form.id) {
                getUserListById(this.form.id).then(response => {
                    this.form.name = response.name
                    this.form.role = response.role
                    this.form.emails = response.emails
                    this.form.description = response.description
                    this.form.enableAlert = response.enableAlert
                    this.form.enableReport = response.enableReport
                    this.form.active = response.active
                    this.form.webhookChannelIds = response.webhookChannelIds
                    if (!this.webhookList.length) {
                        listWebhook().then(res => {
                            res.map(item => {
                                this.webhookList.push({
                                    value: item.id,
                                    label: item.channelName
                                })
                            })
                        })
                    }
                })
            }
        },
        showEditTopic () {
            const row = this.row
            this.form.title = 'Edit Request'
            getRequestById(row.id).then(response => {
                const data = JSON.parse(response.params)
                this.form.id = data.id
                this.form.name = data.name
                this.form.role = data.role
                this.form.emails = data.emails
                this.form.description = data.description
                this.form.enableAlert = data.enableAlert
                this.form.enableReport = data.enableReport
                this.form.active = data.active
                this.form.webhookChannelIds = data.webhookChannelIds
            })
            this.extraLoading = true
            this.extraInfos = []
            getRequestExtraInfo(this.requestParam.type).then(response => {
                response[this.requestParam.type].map(item => {
                    this.extraInfos.push({
                        key: item,
                        value: row.extraInfos[item] ? row.extraInfos[item] : ''
                    })
                })
                this.extraLoading = false
            }).catch(() => {
                this.extraLoading = false
            })
        },
        next () {
            if (!this.active) {
                this.$refs.form.validate((valid) => {
                    if (valid) {
                        this.active++
                    }
                })
            } else {
                this.active++
            }
        },
        save () {
            var extraValid = true
            var extraInfos = {}
            this.extraInfos.map(item => {
                extraInfos[item.key] = item.value
                if (item.value === '') {
                    extraValid = false
                }
            })
            this.$refs.form.validate((valid) => {
                if (valid && extraValid) {
                    this.loading = true
                    var { id, name, emails, role, enableAlert, enableReport, description, active, webhookChannelIds } = this.form
                    const data = { id, name, emails, role, enableAlert, enableReport, description, active, webhookChannelIds }
                    if (!this.row) {
                        this.requestParam.params = data
                        this.requestParam.extraInfos = extraInfos
                        createRequest(this.requestParam).then(response => {
                            this.$message({
                                message: 'Create request success!',
                                type: 'success'
                            })
                            this.$refs.form.resetFields()
                            this.visible = false
                            this.$emit('refreshRequest')
                            this.loading = false
                        }).catch(() => {
                            this.loading = false
                        })
                    } else {
                        this.requestParam.params = data
                        this.requestParam.extraInfos = extraInfos
                        updateRequest(this.row.id, this.requestParam).then(response => {
                            this.$message({
                                message: 'Edit request success!',
                                type: 'success'
                            })
                            this.loading = false
                            this.$refs.form.resetFields()
                            this.visible = false
                            this.$emit('refreshRequest')
                        }).catch(() => {
                            this.loading = false
                        })
                    }
                } else {
                    this.$message({
                        message: 'Submit error!',
                        type: 'error'
                    })
                    return false
                }
            })
        },
        getAllUser () {
            getAllUser().then(response => {
                this.users = response.filter(function (item) {
                    return item.role === 'APP'
                })
            })
        }
    }
}
</script>
<style scoped>
</style>
